import React, { ReactElement, useState } from 'react';
import { NavLink, useLocation, matchPath } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthResources } from 'components';
import IDPShow from '../../../routes/User/IDPShow/IDPModalSelect';
import AppraisalModalSelect from '../../../routes/User/EmployeeAppraisal/AppraisalModalSelect';

// import useStyles from './useStyles';

const MenuBoxComp = (): ReactElement => {
  // const classes = useStyles();

  const { t } = useTranslation('leftMenu');

  const [showModalIDP, setShowModalIDP] = useState<boolean>(false);

  const [showModalAppraisal, setShowModalAppraisal] = useState<boolean>(false);

  function MenuPanel() {
    // const location = useLocation();
    if (matchPath(useLocation().pathname, { path: '/panel' })) {
      return (
        <>
          <NavLink to="/panel/tablica" className="linkItemMenu">
            <div className="accentBefore">
              <svg
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M 10 10 H 10 V 0 C 10 5.5229 5.5229 10 0 10 V 10 V 10 Z"
                  fill="#fff"
                />
              </svg>
            </div>
            <div className="itemMenuBlock">
              <div className="accentActive" />
              <div className="iconItemMenu">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M9.091 4.66666H5.69701C4.96267 4.66666 4.36366 5.26566 4.36366 6.00001V9.99999H6.06069V6.33331H9.091V4.66666ZM27.615 15.5383H25.918V19.205H22.8876V20.8717H26.2816C27.016 20.8717 27.615 20.2727 27.615 19.5383V15.5383ZM29.9697 23.3333H2.03033V2.00003H29.9697V23.3333ZM10.606 30.6666V31.3333C10.606 31.7006 10.9054 32 11.2727 32H20.7273C21.0946 32 21.394 31.7006 21.394 31.3333V30.6666C21.394 30.2993 21.0946 30 20.7273 30H19.0303C18.663 30 18.3636 29.7007 18.3636 29.3333V25.3333H29.6363C30.2733 25.3333 30.86 25.0443 31.2859 24.5757C31.7567 24.058 32 23.3627 32 22.6667V2.66663C32 1.971 31.7563 1.27569 31.2859 0.758334C30.86 0.289692 30.2737 0 29.6363 0H2.36364C0.939635 0 0 1.32065 0 2.66663V22.6667C0 23.3627 0.243325 24.058 0.713983 24.5753C1.14002 25.0443 1.72633 25.3333 2.36364 25.3333H13.6363V29.3333C13.6363 29.7007 13.337 30 12.9697 30H11.2727C10.9054 30 10.606 30.2993 10.606 30.6666Z" />
                </svg>
              </div>
              <div className="itemMenu">{t('menu.desktopUser')}</div>
            </div>
            <div className="accentAfter">
              <svg
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M 0 0 V 0 C 5.5229 0 10 4.4771 10 10 V 10 H 10 V 0 Z"
                  fill="#fff"
                />
              </svg>
            </div>
          </NavLink>
          <AuthResources requiredRoles={['user']}>
            <>
              <NavLink to="/panel/szkolenia" className="linkItemMenu">
                <div className="accentBefore">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M 10 10 H 10 V 0 C 10 5.5229 5.5229 10 0 10 V 10 V 10 Z"
                      fill="#fff"
                    />
                  </svg>
                </div>
                <div className="itemMenuBlock">
                  <div className="accentActive" />
                  <div className="iconItemMenu">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.40017 0C3.75324 0.000562498 1.60019 2.15362 1.60019 4.80054C1.60019 7.44747 3.75324 9.60002 6.40017 9.60002C9.04709 9.60002 11.2001 7.44697 11.2001 4.80004C11.2001 2.15305 9.04709 0 6.40017 0ZM6.40017 8.00053C4.63274 8.00053 3.20018 6.56797 3.20018 4.80054C3.20018 3.03311 4.63274 1.60056 6.40017 1.60056C8.1676 1.60056 9.60015 3.03311 9.60015 4.80054C9.60015 6.56797 8.16766 8.00053 6.40017 8.00053Z"
                        fill="#1D4370"
                      />
                      <path
                        d="M30.4001 7.99997H14.4001C13.5164 7.99997 12.8001 8.71622 12.8001 9.59996V10.8218L14.4001 11.6218V9.59996H30.4001V22.3993H14.4001V20.4975L12.8001 20.098V22.3993C12.8001 23.2831 13.5164 23.9993 14.4001 23.9993H20.9879L16.9142 30.7881C16.686 31.1662 16.8097 31.6585 17.1894 31.8852C17.5644 32.1151 18.0582 31.9913 18.2865 31.61L21.6001 26.0868V31.1988C21.6001 31.6409 21.958 31.9988 22.4001 31.9988C22.8422 31.9988 23.2001 31.6409 23.2001 31.1988V26.0868L26.5142 31.6095C26.6641 31.8596 26.9296 31.9983 27.2001 31.9983C27.3409 31.9983 27.4828 31.9626 27.6113 31.8842C27.991 31.6575 28.1142 31.1652 27.8865 30.7871L23.8128 23.9983H30.4C31.2838 23.9983 32 23.2821 32 22.3983V9.59996C32.0001 8.71622 31.2838 7.99997 30.4001 7.99997Z"
                        fill="#1D4370"
                      />
                      <path
                        d="M27.9686 12.5797C27.8481 12.1546 27.406 11.9045 26.9798 12.0315L17.1073 14.8523C16.9921 14.7408 16.8631 14.6432 16.7159 14.5691L10.3159 11.3691C10.0935 11.2581 9.84871 11.2 9.60015 11.2H3.20018C2.42687 11.2 1.76443 11.7531 1.62581 12.5136L0.025817 21.313C-0.0589952 21.7797 0.0674418 22.2602 0.371441 22.6245C0.675439 22.9887 1.12556 23.1994 1.60025 23.1994H2.62262L3.20555 30.5258C3.27168 31.3578 3.96555 31.9988 4.80023 31.9988H8.00022C8.81566 31.9988 9.50047 31.386 9.59059 30.5759L10.9885 17.9962L15.6124 19.1519C15.7404 19.1839 15.8706 19.1994 16.0002 19.1994C16.3533 19.1994 16.7004 19.0826 16.9847 18.8607C17.373 18.5577 17.6002 18.0921 17.6002 17.5994V16.3743L27.4204 13.5684C27.8455 13.4479 28.0908 13.0042 27.9686 12.5797ZM16.0001 17.5999L9.60015 15.9999L8.00016 30.3994H4.80017L4.10043 21.5994H1.60019L3.20018 12.8H5.60017V17.6672C5.60017 18.1093 5.95804 18.4672 6.40017 18.4672C6.84229 18.4672 7.20016 18.1093 7.20016 17.6672V12.8H9.60015L16.0001 15.9999V17.5999Z"
                        fill="#1D4370"
                      />
                    </svg>
                  </div>
                  <div className="itemMenu">SZKOLENIA</div>
                </div>
                <div className="accentAfter">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M 0 0 V 0 C 5.5229 0 10 4.4771 10 10 V 10 H 10 V 0 Z"
                      fill="#fff"
                    />
                  </svg>
                </div>
              </NavLink>
              <div className="subMenu">
                <div className="fill" />
                <div className="subMenuItemBox">
                  <NavLink
                    to="/panel/szkolenia/plan"
                    className="linkItemSubMenu"
                  >
                    ZAPISY NA SZKOLENIA
                  </NavLink>
                  <NavLink
                    to="/panel/szkolenia/termin-szkolenia"
                    className="linkItemSubMenu"
                  >
                    TERMINY SZKOLEŃ
                  </NavLink>
                  <NavLink
                    to="/panel/szkolenia/ankiety"
                    className="linkItemSubMenu"
                  >
                    ANKIETA PO SZKOLENIU
                  </NavLink>
                </div>
              </div>
              <div
                className="linkItemMenu"
                onClick={() => {
                  setShowModalIDP(true);
                }}
                onKeyDown={() => {}}
                tabIndex={0}
                role="button"
              >
                <div className="accentBefore">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M 10 10 H 10 V 0 C 10 5.5229 5.5229 10 0 10 V 10 V 10 Z"
                      fill="#fff"
                    />
                  </svg>
                </div>
                <div className="itemMenuBlock">
                  <div className="accentActive" />
                  <div className="iconItemMenu">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M29.1876 0H2.81254C1.26164 0 0 1.26164 0 2.81245V29.1875C0 30.7383 1.26164 32 2.81254 32H29.1876C30.7384 32 32 30.7384 32 29.1875V2.81245C32 1.26164 30.7384 0 29.1876 0ZM1.87503 2.81245C1.87503 2.29554 2.29554 1.87503 2.81254 1.87503H22.625V7.50002H1.87503V2.81245ZM30.125 29.1875C30.125 29.7045 29.7045 30.125 29.1876 30.125H2.81254C2.29554 30.125 1.87503 29.7045 1.87503 29.1875V9.37495H30.125V29.1875ZM30.125 7.50002H24.5V1.87503H29.1876C29.7045 1.87503 30.125 2.29554 30.125 2.81245V7.50002ZM6.5625 3.74996H4.68748C4.1697 3.74996 3.74996 4.1697 3.74996 4.68748C3.74996 5.20525 4.1697 5.62499 4.68748 5.62499H6.5625C7.08027 5.62499 7.50002 5.20525 7.50002 4.68748C7.50002 4.1698 7.08027 3.74996 6.5625 3.74996ZM12.25 3.74996H10.375C9.85729 3.74996 9.43754 4.1697 9.43754 4.68748C9.43754 5.20525 9.85729 5.62499 10.375 5.62499H12.25C12.7678 5.62499 13.1875 5.20525 13.1875 4.68748C13.1875 4.1698 12.7678 3.74996 12.25 3.74996ZM17.875 3.74996H16C15.4823 3.74996 15.0625 4.1697 15.0625 4.68748C15.0625 5.20525 15.4823 5.62499 16 5.62499H17.875C18.3928 5.62499 18.8125 5.20525 18.8125 4.68748C18.8125 4.1698 18.3928 3.74996 17.875 3.74996ZM27.3125 26.375H26.375V14.125C26.375 13.6072 25.9553 13.1875 25.4375 13.1875H21.6875C21.1698 13.1875 20.75 13.6072 20.75 14.125V26.375H18.8125V17.875C18.8125 17.3572 18.3928 16.9375 17.875 16.9375H14.125C13.6072 16.9375 13.1875 17.3572 13.1875 17.875V26.375H11.3125V21.6249C11.3125 21.1073 10.8927 20.6875 10.3751 20.6875H6.5625C6.04473 20.6875 5.62499 21.1073 5.62499 21.6249V26.375H4.68748C4.1697 26.375 3.74996 26.7948 3.74996 27.3125C3.74996 27.8302 4.1697 28.2499 4.68748 28.2499C12.2352 28.2499 19.764 28.2499 27.3125 28.2499C27.8303 28.2499 28.25 27.8302 28.25 27.3125C28.25 26.7948 27.8303 26.375 27.3125 26.375ZM9.43754 26.375H7.50002V22.5625H9.43754V26.375ZM16.9375 26.375H15.0625V18.8125H16.9375V26.375ZM24.5 26.375H22.625V15.0625H24.5V26.375Z"
                        fill="#1D4370"
                      />
                    </svg>
                  </div>
                  <div className="itemMenu">PODGLĄD IDP</div>
                </div>
                <div className="accentAfter">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M 0 0 V 0 C 5.5229 0 10 4.4771 10 10 V 10 H 10 V 0 Z"
                      fill="#fff"
                    />
                  </svg>
                </div>
              </div>
              <NavLink to="/panel/IDP" className="linkItemMenu">
                <div className="accentBefore">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M 10 10 H 10 V 0 C 10 5.5229 5.5229 10 0 10 V 10 V 10 Z"
                      fill="#fff"
                    />
                  </svg>
                </div>
                <div className="itemMenuBlock">
                  <div className="accentActive" />
                  <div className="iconItemMenu">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M29.1876 0H2.81254C1.26164 0 0 1.26164 0 2.81245V29.1875C0 30.7383 1.26164 32 2.81254 32H29.1876C30.7384 32 32 30.7384 32 29.1875V2.81245C32 1.26164 30.7384 0 29.1876 0ZM1.87503 2.81245C1.87503 2.29554 2.29554 1.87503 2.81254 1.87503H22.625V7.50002H1.87503V2.81245ZM30.125 29.1875C30.125 29.7045 29.7045 30.125 29.1876 30.125H2.81254C2.29554 30.125 1.87503 29.7045 1.87503 29.1875V9.37495H30.125V29.1875ZM30.125 7.50002H24.5V1.87503H29.1876C29.7045 1.87503 30.125 2.29554 30.125 2.81245V7.50002ZM6.5625 3.74996H4.68748C4.1697 3.74996 3.74996 4.1697 3.74996 4.68748C3.74996 5.20525 4.1697 5.62499 4.68748 5.62499H6.5625C7.08027 5.62499 7.50002 5.20525 7.50002 4.68748C7.50002 4.1698 7.08027 3.74996 6.5625 3.74996ZM12.25 3.74996H10.375C9.85729 3.74996 9.43754 4.1697 9.43754 4.68748C9.43754 5.20525 9.85729 5.62499 10.375 5.62499H12.25C12.7678 5.62499 13.1875 5.20525 13.1875 4.68748C13.1875 4.1698 12.7678 3.74996 12.25 3.74996ZM17.875 3.74996H16C15.4823 3.74996 15.0625 4.1697 15.0625 4.68748C15.0625 5.20525 15.4823 5.62499 16 5.62499H17.875C18.3928 5.62499 18.8125 5.20525 18.8125 4.68748C18.8125 4.1698 18.3928 3.74996 17.875 3.74996ZM27.3125 26.375H26.375V14.125C26.375 13.6072 25.9553 13.1875 25.4375 13.1875H21.6875C21.1698 13.1875 20.75 13.6072 20.75 14.125V26.375H18.8125V17.875C18.8125 17.3572 18.3928 16.9375 17.875 16.9375H14.125C13.6072 16.9375 13.1875 17.3572 13.1875 17.875V26.375H11.3125V21.6249C11.3125 21.1073 10.8927 20.6875 10.3751 20.6875H6.5625C6.04473 20.6875 5.62499 21.1073 5.62499 21.6249V26.375H4.68748C4.1697 26.375 3.74996 26.7948 3.74996 27.3125C3.74996 27.8302 4.1697 28.2499 4.68748 28.2499C12.2352 28.2499 19.764 28.2499 27.3125 28.2499C27.8303 28.2499 28.25 27.8302 28.25 27.3125C28.25 26.7948 27.8303 26.375 27.3125 26.375ZM9.43754 26.375H7.50002V22.5625H9.43754V26.375ZM16.9375 26.375H15.0625V18.8125H16.9375V26.375ZM24.5 26.375H22.625V15.0625H24.5V26.375Z"
                        fill="#1D4370"
                      />
                    </svg>
                  </div>
                  <div className="itemMenu">EDYCJA IDP</div>
                </div>
                <div className="accentAfter">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M 0 0 V 0 C 5.5229 0 10 4.4771 10 10 V 10 H 10 V 0 Z"
                      fill="#fff"
                    />
                  </svg>
                </div>
              </NavLink>
              <div
                className="linkItemMenu"
                onClick={() => {
                  setShowModalAppraisal(true);
                }}
                onKeyDown={() => {}}
                tabIndex={0}
                role="button"
              >
                <div className="accentBefore">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M 10 10 H 10 V 0 C 10 5.5229 5.5229 10 0 10 V 10 V 10 Z"
                      fill="#fff"
                    />
                  </svg>
                </div>
                <div className="itemMenuBlock">
                  <div className="accentActive" />
                  <div className="iconItemMenu">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M25.1131 14.3269L28.1675 11.3498C28.4443 11.0799 28.5441 10.6756 28.4246 10.3079C28.3051 9.93997 27.9871 9.67185 27.6044 9.6162L18.9976 8.36535L15.1486 0.566523C14.9773 0.219414 14.624 0 14.237 0C13.8502 0 13.4969 0.219619 13.3256 0.566523L9.47675 8.36535L0.86992 9.6162C0.487139 9.67185 0.169175 9.93987 0.049633 10.3079C-0.0697046 10.6756 0.0300674 11.0799 0.306858 11.3498L6.53467 17.4203L5.06439 25.9919C4.99927 26.3717 5.15723 26.7596 5.46878 26.9861C5.64264 27.1126 5.85145 27.1802 6.06628 27.1802C6.23118 27.1802 6.39322 27.1402 6.53915 27.0635L14.0904 23.0936L14.1175 23.5678C14.3876 28.2907 18.3187 32 23.0511 32C27.9854 32 32 27.9854 32 23.0511C32 19.0977 29.3892 15.6059 25.6112 14.4759L25.1131 14.3269ZM14.162 20.8569C14.023 20.8671 13.8876 20.9035 13.7641 20.9685L7.4161 24.306L8.62834 17.2374C8.6848 16.9083 8.57514 16.5708 8.33606 16.3377L3.20023 11.3317L10.2978 10.3002C10.6288 10.2521 10.915 10.0443 11.0631 9.7443L14.237 3.31282L17.4112 9.7442C17.5592 10.0441 17.8454 10.252 18.1763 10.3001L25.2738 11.3316L22.4081 14.125L22.2987 14.1342C18.5861 14.4445 15.4392 17.0541 14.4338 20.6346L14.3758 20.8411L14.162 20.8569ZM23.0511 29.9673C19.2373 29.9673 16.1349 26.8648 16.1349 23.0511C16.1349 19.2374 19.2373 16.135 23.0511 16.135C26.8648 16.135 29.9673 19.2374 29.9673 23.0511C29.9673 26.8649 26.8649 29.9673 23.0511 29.9673ZM25.1529 20.3934L21.9053 23.6409L20.8611 22.597C20.464 22.2 19.8208 22.2 19.4237 22.597C19.0267 22.9938 19.0268 23.6373 19.4237 24.0342L21.1865 25.7971C21.378 25.9885 21.6346 26.0947 21.9053 26.0947C22.1759 26.0947 22.4325 25.9884 22.6239 25.797L26.5902 21.8307C26.9872 21.4338 26.9872 20.7903 26.5902 20.3934C26.1933 19.9964 25.5498 19.9964 25.1529 20.3934Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div className="itemMenu">PODGLĄD OCENY PRACOWNIKA</div>
                </div>
                <div className="accentAfter">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M 0 0 V 0 C 5.5229 0 10 4.4771 10 10 V 10 H 10 V 0 Z"
                      fill="#fff"
                    />
                  </svg>
                </div>
              </div>
              <NavLink to="/panel/ocena-pracownika" className="linkItemMenu">
                <div className="accentBefore">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M 10 10 H 10 V 0 C 10 5.5229 5.5229 10 0 10 V 10 V 10 Z"
                      fill="#fff"
                    />
                  </svg>
                </div>
                <div className="itemMenuBlock">
                  <div className="accentActive" />
                  <div className="iconItemMenu">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M25.1131 14.3269L28.1675 11.3498C28.4443 11.0799 28.5441 10.6756 28.4246 10.3079C28.3051 9.93997 27.9871 9.67185 27.6044 9.6162L18.9976 8.36535L15.1486 0.566523C14.9773 0.219414 14.624 0 14.237 0C13.8502 0 13.4969 0.219619 13.3256 0.566523L9.47675 8.36535L0.86992 9.6162C0.487139 9.67185 0.169175 9.93987 0.049633 10.3079C-0.0697046 10.6756 0.0300674 11.0799 0.306858 11.3498L6.53467 17.4203L5.06439 25.9919C4.99927 26.3717 5.15723 26.7596 5.46878 26.9861C5.64264 27.1126 5.85145 27.1802 6.06628 27.1802C6.23118 27.1802 6.39322 27.1402 6.53915 27.0635L14.0904 23.0936L14.1175 23.5678C14.3876 28.2907 18.3187 32 23.0511 32C27.9854 32 32 27.9854 32 23.0511C32 19.0977 29.3892 15.6059 25.6112 14.4759L25.1131 14.3269ZM14.162 20.8569C14.023 20.8671 13.8876 20.9035 13.7641 20.9685L7.4161 24.306L8.62834 17.2374C8.6848 16.9083 8.57514 16.5708 8.33606 16.3377L3.20023 11.3317L10.2978 10.3002C10.6288 10.2521 10.915 10.0443 11.0631 9.7443L14.237 3.31282L17.4112 9.7442C17.5592 10.0441 17.8454 10.252 18.1763 10.3001L25.2738 11.3316L22.4081 14.125L22.2987 14.1342C18.5861 14.4445 15.4392 17.0541 14.4338 20.6346L14.3758 20.8411L14.162 20.8569ZM23.0511 29.9673C19.2373 29.9673 16.1349 26.8648 16.1349 23.0511C16.1349 19.2374 19.2373 16.135 23.0511 16.135C26.8648 16.135 29.9673 19.2374 29.9673 23.0511C29.9673 26.8649 26.8649 29.9673 23.0511 29.9673ZM25.1529 20.3934L21.9053 23.6409L20.8611 22.597C20.464 22.2 19.8208 22.2 19.4237 22.597C19.0267 22.9938 19.0268 23.6373 19.4237 24.0342L21.1865 25.7971C21.378 25.9885 21.6346 26.0947 21.9053 26.0947C22.1759 26.0947 22.4325 25.9884 22.6239 25.797L26.5902 21.8307C26.9872 21.4338 26.9872 20.7903 26.5902 20.3934C26.1933 19.9964 25.5498 19.9964 25.1529 20.3934Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div className="itemMenu">OCENA PRACOWNIKA</div>
                </div>
                <div className="accentAfter">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M 0 0 V 0 C 5.5229 0 10 4.4771 10 10 V 10 H 10 V 0 Z"
                      fill="#fff"
                    />
                  </svg>
                </div>
              </NavLink>
            </>
          </AuthResources>
        </>
      );
    }
  }

  function MenuManager() {
    // const location = useLocation();
    if (matchPath(useLocation().pathname, { path: '/kierownik' })) {
      return (
        <>
          <AuthResources requiredRoles={['manager', 'second-level-manager']}>
            <>
              <NavLink to="/kierownik/tablica" className="linkItemMenu">
                <div className="itemMenuBlock">
                  <div className="accentActive" />
                  <div className="iconItemMenu">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M9.091 4.66666H5.69701C4.96267 4.66666 4.36366 5.26566 4.36366 6.00001V9.99999H6.06069V6.33331H9.091V4.66666ZM27.615 15.5383H25.918V19.205H22.8876V20.8717H26.2816C27.016 20.8717 27.615 20.2727 27.615 19.5383V15.5383ZM29.9697 23.3333H2.03033V2.00003H29.9697V23.3333ZM10.606 30.6666V31.3333C10.606 31.7006 10.9054 32 11.2727 32H20.7273C21.0946 32 21.394 31.7006 21.394 31.3333V30.6666C21.394 30.2993 21.0946 30 20.7273 30H19.0303C18.663 30 18.3636 29.7007 18.3636 29.3333V25.3333H29.6363C30.2733 25.3333 30.86 25.0443 31.2859 24.5757C31.7567 24.058 32 23.3627 32 22.6667V2.66663C32 1.971 31.7563 1.27569 31.2859 0.758334C30.86 0.289692 30.2737 0 29.6363 0H2.36364C0.939635 0 0 1.32065 0 2.66663V22.6667C0 23.3627 0.243325 24.058 0.713983 24.5753C1.14002 25.0443 1.72633 25.3333 2.36364 25.3333H13.6363V29.3333C13.6363 29.7007 13.337 30 12.9697 30H11.2727C10.9054 30 10.606 30.2993 10.606 30.6666Z" />
                    </svg>
                  </div>
                  <div className="itemMenu">{t('menu.desktopManager')}</div>
                </div>
                <div className="accentAfter">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M 0 0 V 0 C 5.5229 0 10 4.4771 10 10 V 10 H 10 V 0 Z"
                      fill="#fff"
                    />
                  </svg>
                </div>
              </NavLink>

              <NavLink to="/kierownik/szkolenia" className="linkItemMenu">
                <div className="accentBefore">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M 10 10 H 10 V 0 C 10 5.5229 5.5229 10 0 10 V 10 V 10 Z"
                      fill="#fff"
                    />
                  </svg>
                </div>
                <div className="itemMenuBlock">
                  <div className="accentActive" />
                  <div className="iconItemMenu">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.40017 0C3.75324 0.000562498 1.60019 2.15362 1.60019 4.80054C1.60019 7.44747 3.75324 9.60002 6.40017 9.60002C9.04709 9.60002 11.2001 7.44697 11.2001 4.80004C11.2001 2.15305 9.04709 0 6.40017 0ZM6.40017 8.00053C4.63274 8.00053 3.20018 6.56797 3.20018 4.80054C3.20018 3.03311 4.63274 1.60056 6.40017 1.60056C8.1676 1.60056 9.60015 3.03311 9.60015 4.80054C9.60015 6.56797 8.16766 8.00053 6.40017 8.00053Z"
                        fill="#1D4370"
                      />
                      <path
                        d="M30.4001 7.99997H14.4001C13.5164 7.99997 12.8001 8.71622 12.8001 9.59996V10.8218L14.4001 11.6218V9.59996H30.4001V22.3993H14.4001V20.4975L12.8001 20.098V22.3993C12.8001 23.2831 13.5164 23.9993 14.4001 23.9993H20.9879L16.9142 30.7881C16.686 31.1662 16.8097 31.6585 17.1894 31.8852C17.5644 32.1151 18.0582 31.9913 18.2865 31.61L21.6001 26.0868V31.1988C21.6001 31.6409 21.958 31.9988 22.4001 31.9988C22.8422 31.9988 23.2001 31.6409 23.2001 31.1988V26.0868L26.5142 31.6095C26.6641 31.8596 26.9296 31.9983 27.2001 31.9983C27.3409 31.9983 27.4828 31.9626 27.6113 31.8842C27.991 31.6575 28.1142 31.1652 27.8865 30.7871L23.8128 23.9983H30.4C31.2838 23.9983 32 23.2821 32 22.3983V9.59996C32.0001 8.71622 31.2838 7.99997 30.4001 7.99997Z"
                        fill="#1D4370"
                      />
                      <path
                        d="M27.9686 12.5797C27.8481 12.1546 27.406 11.9045 26.9798 12.0315L17.1073 14.8523C16.9921 14.7408 16.8631 14.6432 16.7159 14.5691L10.3159 11.3691C10.0935 11.2581 9.84871 11.2 9.60015 11.2H3.20018C2.42687 11.2 1.76443 11.7531 1.62581 12.5136L0.025817 21.313C-0.0589952 21.7797 0.0674418 22.2602 0.371441 22.6245C0.675439 22.9887 1.12556 23.1994 1.60025 23.1994H2.62262L3.20555 30.5258C3.27168 31.3578 3.96555 31.9988 4.80023 31.9988H8.00022C8.81566 31.9988 9.50047 31.386 9.59059 30.5759L10.9885 17.9962L15.6124 19.1519C15.7404 19.1839 15.8706 19.1994 16.0002 19.1994C16.3533 19.1994 16.7004 19.0826 16.9847 18.8607C17.373 18.5577 17.6002 18.0921 17.6002 17.5994V16.3743L27.4204 13.5684C27.8455 13.4479 28.0908 13.0042 27.9686 12.5797ZM16.0001 17.5999L9.60015 15.9999L8.00016 30.3994H4.80017L4.10043 21.5994H1.60019L3.20018 12.8H5.60017V17.6672C5.60017 18.1093 5.95804 18.4672 6.40017 18.4672C6.84229 18.4672 7.20016 18.1093 7.20016 17.6672V12.8H9.60015L16.0001 15.9999V17.5999Z"
                        fill="#1D4370"
                      />
                    </svg>
                  </div>
                  <div className="itemMenu">SZKOLENIA</div>
                </div>
                <div className="accentAfter">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M 0 0 V 0 C 5.5229 0 10 4.4771 10 10 V 10 H 10 V 0 Z"
                      fill="#fff"
                    />
                  </svg>
                </div>
              </NavLink>
              <div className="subMenu">
                <div className="fill" />
                <div className="subMenuItemBox">
                  <NavLink
                    to="/kierownik/szkolenia/plan"
                    className="linkItemSubMenu"
                  >
                    ZAPISY NA SZKOLENIA
                  </NavLink>
                  <NavLink
                    to="/kierownik/szkolenia/grupy-szkoleniowe"
                    className="linkItemSubMenu"
                  >
                    TERMINY SZKOLEŃ
                  </NavLink>
                </div>
              </div>
              <NavLink to="/kierownik/IDP" className="linkItemMenu">
                <div className="accentBefore">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M 10 10 H 10 V 0 C 10 5.5229 5.5229 10 0 10 V 10 V 10 Z"
                      fill="#fff"
                    />
                  </svg>
                </div>
                <div className="itemMenuBlock">
                  <div className="accentActive" />
                  <div className="iconItemMenu">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M29.1876 0H2.81254C1.26164 0 0 1.26164 0 2.81245V29.1875C0 30.7383 1.26164 32 2.81254 32H29.1876C30.7384 32 32 30.7384 32 29.1875V2.81245C32 1.26164 30.7384 0 29.1876 0ZM1.87503 2.81245C1.87503 2.29554 2.29554 1.87503 2.81254 1.87503H22.625V7.50002H1.87503V2.81245ZM30.125 29.1875C30.125 29.7045 29.7045 30.125 29.1876 30.125H2.81254C2.29554 30.125 1.87503 29.7045 1.87503 29.1875V9.37495H30.125V29.1875ZM30.125 7.50002H24.5V1.87503H29.1876C29.7045 1.87503 30.125 2.29554 30.125 2.81245V7.50002ZM6.5625 3.74996H4.68748C4.1697 3.74996 3.74996 4.1697 3.74996 4.68748C3.74996 5.20525 4.1697 5.62499 4.68748 5.62499H6.5625C7.08027 5.62499 7.50002 5.20525 7.50002 4.68748C7.50002 4.1698 7.08027 3.74996 6.5625 3.74996ZM12.25 3.74996H10.375C9.85729 3.74996 9.43754 4.1697 9.43754 4.68748C9.43754 5.20525 9.85729 5.62499 10.375 5.62499H12.25C12.7678 5.62499 13.1875 5.20525 13.1875 4.68748C13.1875 4.1698 12.7678 3.74996 12.25 3.74996ZM17.875 3.74996H16C15.4823 3.74996 15.0625 4.1697 15.0625 4.68748C15.0625 5.20525 15.4823 5.62499 16 5.62499H17.875C18.3928 5.62499 18.8125 5.20525 18.8125 4.68748C18.8125 4.1698 18.3928 3.74996 17.875 3.74996ZM27.3125 26.375H26.375V14.125C26.375 13.6072 25.9553 13.1875 25.4375 13.1875H21.6875C21.1698 13.1875 20.75 13.6072 20.75 14.125V26.375H18.8125V17.875C18.8125 17.3572 18.3928 16.9375 17.875 16.9375H14.125C13.6072 16.9375 13.1875 17.3572 13.1875 17.875V26.375H11.3125V21.6249C11.3125 21.1073 10.8927 20.6875 10.3751 20.6875H6.5625C6.04473 20.6875 5.62499 21.1073 5.62499 21.6249V26.375H4.68748C4.1697 26.375 3.74996 26.7948 3.74996 27.3125C3.74996 27.8302 4.1697 28.2499 4.68748 28.2499C12.2352 28.2499 19.764 28.2499 27.3125 28.2499C27.8303 28.2499 28.25 27.8302 28.25 27.3125C28.25 26.7948 27.8303 26.375 27.3125 26.375ZM9.43754 26.375H7.50002V22.5625H9.43754V26.375ZM16.9375 26.375H15.0625V18.8125H16.9375V26.375ZM24.5 26.375H22.625V15.0625H24.5V26.375Z"
                        fill="#1D4370"
                      />
                    </svg>
                  </div>
                  <div className="itemMenu">INDYWIDUALNY PLAN ROZWOJU</div>
                </div>
                <div className="accentAfter">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M 0 0 V 0 C 5.5229 0 10 4.4771 10 10 V 10 H 10 V 0 Z"
                      fill="#fff"
                    />
                  </svg>
                </div>
              </NavLink>
              <div className="subMenu">
                <div className="fill" />
                <div className="subMenuItemBox">
                  <NavLink
                    to="/kierownik/IDP/pracownicy"
                    className="linkItemSubMenu"
                  >
                    LISTA PRACOWNIKÓW
                  </NavLink>
                  <NavLink
                    to="/kierownik/IDP/pracownik/feedback"
                    className="linkItemSubMenu"
                  >
                    FEEDBACK
                  </NavLink>
                </div>
              </div>
              <NavLink
                to="/kierownik/ocena-pracownika"
                className="linkItemMenu"
              >
                <div className="accentBefore">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M 10 10 H 10 V 0 C 10 5.5229 5.5229 10 0 10 V 10 V 10 Z"
                      fill="#fff"
                    />
                  </svg>
                </div>
                <div className="itemMenuBlock">
                  <div className="accentActive" />
                  <div className="iconItemMenu">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M25.1131 14.3269L28.1675 11.3498C28.4443 11.0799 28.5441 10.6756 28.4246 10.3079C28.3051 9.93997 27.9871 9.67185 27.6044 9.6162L18.9976 8.36535L15.1486 0.566523C14.9773 0.219414 14.624 0 14.237 0C13.8502 0 13.4969 0.219619 13.3256 0.566523L9.47675 8.36535L0.86992 9.6162C0.487139 9.67185 0.169175 9.93987 0.049633 10.3079C-0.0697046 10.6756 0.0300674 11.0799 0.306858 11.3498L6.53467 17.4203L5.06439 25.9919C4.99927 26.3717 5.15723 26.7596 5.46878 26.9861C5.64264 27.1126 5.85145 27.1802 6.06628 27.1802C6.23118 27.1802 6.39322 27.1402 6.53915 27.0635L14.0904 23.0936L14.1175 23.5678C14.3876 28.2907 18.3187 32 23.0511 32C27.9854 32 32 27.9854 32 23.0511C32 19.0977 29.3892 15.6059 25.6112 14.4759L25.1131 14.3269ZM14.162 20.8569C14.023 20.8671 13.8876 20.9035 13.7641 20.9685L7.4161 24.306L8.62834 17.2374C8.6848 16.9083 8.57514 16.5708 8.33606 16.3377L3.20023 11.3317L10.2978 10.3002C10.6288 10.2521 10.915 10.0443 11.0631 9.7443L14.237 3.31282L17.4112 9.7442C17.5592 10.0441 17.8454 10.252 18.1763 10.3001L25.2738 11.3316L22.4081 14.125L22.2987 14.1342C18.5861 14.4445 15.4392 17.0541 14.4338 20.6346L14.3758 20.8411L14.162 20.8569ZM23.0511 29.9673C19.2373 29.9673 16.1349 26.8648 16.1349 23.0511C16.1349 19.2374 19.2373 16.135 23.0511 16.135C26.8648 16.135 29.9673 19.2374 29.9673 23.0511C29.9673 26.8649 26.8649 29.9673 23.0511 29.9673ZM25.1529 20.3934L21.9053 23.6409L20.8611 22.597C20.464 22.2 19.8208 22.2 19.4237 22.597C19.0267 22.9938 19.0268 23.6373 19.4237 24.0342L21.1865 25.7971C21.378 25.9885 21.6346 26.0947 21.9053 26.0947C22.1759 26.0947 22.4325 25.9884 22.6239 25.797L26.5902 21.8307C26.9872 21.4338 26.9872 20.7903 26.5902 20.3934C26.1933 19.9964 25.5498 19.9964 25.1529 20.3934Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div className="itemMenu">OCENA PRACOWNIKA</div>
                </div>
                <div className="accentAfter">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M 0 0 V 0 C 5.5229 0 10 4.4771 10 10 V 10 H 10 V 0 Z"
                      fill="#fff"
                    />
                  </svg>
                </div>
              </NavLink>
              <div className="subMenu">
                <div className="fill" />
                <div className="subMenuItemBox">
                  <NavLink
                    to="/kierownik/ocena-pracownika/pracownik"
                    className="linkItemSubMenu"
                  >
                    LISTA PRACOWNIKÓW
                  </NavLink>
                  <AuthResources requiredRoles={['second-level-manager']}>
                    <>
                      <NavLink
                        to="/kierownik/ocena-pracownika/grupowa-ocena"
                        className="linkItemSubMenu"
                      >
                        GRUPOWA OCENA
                      </NavLink>
                    </>
                  </AuthResources>
                </div>
              </div>
            </>
          </AuthResources>
        </>
      );
    }
  }

  function MenuAdministration() {
    // const location = useLocation();
    if (matchPath(useLocation().pathname, { path: '/administracja' })) {
      return (
        <AuthResources
          requiredRoles={[
            'training_department',
            'hr_bp',
            'slt_department',
            'admin_phr',
          ]}
        >
          <>
            <NavLink to="/administracja/tablica" className="linkItemMenu">
              <div className="itemMenuBlock">
                <div className="accentActive" />
                <div className="iconItemMenu">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M9.091 4.66666H5.69701C4.96267 4.66666 4.36366 5.26566 4.36366 6.00001V9.99999H6.06069V6.33331H9.091V4.66666ZM27.615 15.5383H25.918V19.205H22.8876V20.8717H26.2816C27.016 20.8717 27.615 20.2727 27.615 19.5383V15.5383ZM29.9697 23.3333H2.03033V2.00003H29.9697V23.3333ZM10.606 30.6666V31.3333C10.606 31.7006 10.9054 32 11.2727 32H20.7273C21.0946 32 21.394 31.7006 21.394 31.3333V30.6666C21.394 30.2993 21.0946 30 20.7273 30H19.0303C18.663 30 18.3636 29.7007 18.3636 29.3333V25.3333H29.6363C30.2733 25.3333 30.86 25.0443 31.2859 24.5757C31.7567 24.058 32 23.3627 32 22.6667V2.66663C32 1.971 31.7563 1.27569 31.2859 0.758334C30.86 0.289692 30.2737 0 29.6363 0H2.36364C0.939635 0 0 1.32065 0 2.66663V22.6667C0 23.3627 0.243325 24.058 0.713983 24.5753C1.14002 25.0443 1.72633 25.3333 2.36364 25.3333H13.6363V29.3333C13.6363 29.7007 13.337 30 12.9697 30H11.2727C10.9054 30 10.606 30.2993 10.606 30.6666Z" />
                  </svg>
                </div>
                <div className="itemMenu">
                  {t('menu.desktopAdministration')}
                </div>
              </div>
              <div className="accentAfter">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M 0 0 V 0 C 5.5229 0 10 4.4771 10 10 V 10 H 10 V 0 Z"
                    fill="#fff"
                  />
                </svg>
              </div>
            </NavLink>
            <NavLink to="/administracja/szkolenia" className="linkItemMenu">
              <div className="accentBefore">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M 10 10 H 10 V 0 C 10 5.5229 5.5229 10 0 10 V 10 V 10 Z"
                    fill="#fff"
                  />
                </svg>
              </div>
              <div className="itemMenuBlock">
                <div className="accentActive" />
                <div className="iconItemMenu">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.40017 0C3.75324 0.000562498 1.60019 2.15362 1.60019 4.80054C1.60019 7.44747 3.75324 9.60002 6.40017 9.60002C9.04709 9.60002 11.2001 7.44697 11.2001 4.80004C11.2001 2.15305 9.04709 0 6.40017 0ZM6.40017 8.00053C4.63274 8.00053 3.20018 6.56797 3.20018 4.80054C3.20018 3.03311 4.63274 1.60056 6.40017 1.60056C8.1676 1.60056 9.60015 3.03311 9.60015 4.80054C9.60015 6.56797 8.16766 8.00053 6.40017 8.00053Z"
                      fill="#1D4370"
                    />
                    <path
                      d="M30.4001 7.99997H14.4001C13.5164 7.99997 12.8001 8.71622 12.8001 9.59996V10.8218L14.4001 11.6218V9.59996H30.4001V22.3993H14.4001V20.4975L12.8001 20.098V22.3993C12.8001 23.2831 13.5164 23.9993 14.4001 23.9993H20.9879L16.9142 30.7881C16.686 31.1662 16.8097 31.6585 17.1894 31.8852C17.5644 32.1151 18.0582 31.9913 18.2865 31.61L21.6001 26.0868V31.1988C21.6001 31.6409 21.958 31.9988 22.4001 31.9988C22.8422 31.9988 23.2001 31.6409 23.2001 31.1988V26.0868L26.5142 31.6095C26.6641 31.8596 26.9296 31.9983 27.2001 31.9983C27.3409 31.9983 27.4828 31.9626 27.6113 31.8842C27.991 31.6575 28.1142 31.1652 27.8865 30.7871L23.8128 23.9983H30.4C31.2838 23.9983 32 23.2821 32 22.3983V9.59996C32.0001 8.71622 31.2838 7.99997 30.4001 7.99997Z"
                      fill="#1D4370"
                    />
                    <path
                      d="M27.9686 12.5797C27.8481 12.1546 27.406 11.9045 26.9798 12.0315L17.1073 14.8523C16.9921 14.7408 16.8631 14.6432 16.7159 14.5691L10.3159 11.3691C10.0935 11.2581 9.84871 11.2 9.60015 11.2H3.20018C2.42687 11.2 1.76443 11.7531 1.62581 12.5136L0.025817 21.313C-0.0589952 21.7797 0.0674418 22.2602 0.371441 22.6245C0.675439 22.9887 1.12556 23.1994 1.60025 23.1994H2.62262L3.20555 30.5258C3.27168 31.3578 3.96555 31.9988 4.80023 31.9988H8.00022C8.81566 31.9988 9.50047 31.386 9.59059 30.5759L10.9885 17.9962L15.6124 19.1519C15.7404 19.1839 15.8706 19.1994 16.0002 19.1994C16.3533 19.1994 16.7004 19.0826 16.9847 18.8607C17.373 18.5577 17.6002 18.0921 17.6002 17.5994V16.3743L27.4204 13.5684C27.8455 13.4479 28.0908 13.0042 27.9686 12.5797ZM16.0001 17.5999L9.60015 15.9999L8.00016 30.3994H4.80017L4.10043 21.5994H1.60019L3.20018 12.8H5.60017V17.6672C5.60017 18.1093 5.95804 18.4672 6.40017 18.4672C6.84229 18.4672 7.20016 18.1093 7.20016 17.6672V12.8H9.60015L16.0001 15.9999V17.5999Z"
                      fill="#1D4370"
                    />
                  </svg>
                </div>
                <div className="itemMenu">SZKOLENIA</div>
              </div>
              <div className="accentAfter">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M 0 0 V 0 C 5.5229 0 10 4.4771 10 10 V 10 H 10 V 0 Z"
                    fill="#fff"
                  />
                </svg>
              </div>
            </NavLink>
            <div className="subMenu">
              <div className="fill" />
              <div className="subMenuItemBox">
                <NavLink
                  to="/administracja/szkolenia/akceptacja-szkolen/pracownicy"
                  className="linkItemSubMenu"
                >
                  AKCEPTACJA SZKOLEŃ
                </NavLink>
                <AuthResources requiredRoles={['training_department']}>
                  <NavLink
                    to="/administracja/szkolenia/grupy-szkoleniowe"
                    className="linkItemSubMenu"
                  >
                    GRUPY SZKOLENIOWE
                  </NavLink>
                </AuthResources>
                <AuthResources requiredRoles={['admin_phr']}>
                  <NavLink
                    to="/administracja/szkolenia/plan"
                    className="linkItemSubMenu"
                  >
                    LISTA PRACOWNIKÓW
                  </NavLink>
                </AuthResources>
              </div>
            </div>
            <AuthResources requiredRoles={['training_department']}>
              <NavLink
                to="/administracja/umowy-lojalnosciowe"
                className="linkItemMenu"
              >
                <div className="accentBefore">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M 10 10 H 10 V 0 C 10 5.5229 5.5229 10 0 10 V 10 V 10 Z"
                      fill="#fff"
                    />
                  </svg>
                </div>
                <div className="itemMenuBlock">
                  <div className="accentActive" />
                  <div className="iconItemMenu">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M32 6.80736L30.6778 5.4816L29.0421 7.1216C27.9703 6.50416 26.5756 6.65344 25.6608 7.57088L25.1086 8.12432V0.800002C25.1086 0.359359 24.7501 0 24.3108 0H5.26211C5.04254 0 4.85328 0.0785579 4.69802 0.234239L0.233615 4.71056C0.0785097 4.86624 0 5.056 0 5.27616V31.2C0 31.6405 0.358402 32 0.797871 32H24.3108C24.7502 32 25.1086 31.6406 25.1086 31.2V16.6582L29.9163 11.8378C30.8313 10.9203 30.9803 9.52208 30.3645 8.44736L32 6.80736ZM13.5293 22.6704L14.857 24.0016L12.5559 24.9776L13.5293 22.6704ZM16.3209 22.8178L14.71 21.2026L24.9997 10.8854L26.6106 12.5008L16.3209 22.8178ZM5.44115 4.072V4.65552C5.44115 5.096 5.08275 5.45552 4.64328 5.45552H4.06132C3.7318 5.45552 3.45031 5.26688 3.32424 4.9616C3.19818 4.65632 3.26424 4.32336 3.49722 4.08976L4.07919 3.5064C4.31232 3.2728 4.64424 3.20656 4.94871 3.33296C5.25318 3.45936 5.44115 3.74176 5.44115 4.072ZM22.4409 30.125H2.66792C2.22861 30.125 1.87005 29.7656 1.87005 29.325V7.33056H6.51317C6.95264 7.33056 7.31104 6.9712 7.31104 6.53056V2.67504C7.31104 2.2344 7.66944 1.87504 8.10891 1.87504H22.4409C22.8804 1.87504 23.2388 2.23456 23.2388 2.67504V9.99936L20.2903 12.9555H5.57982C5.14051 12.9555 4.78195 13.315 4.78195 13.7555V14.0306C4.78195 14.471 5.14035 14.8306 5.57982 14.8306H18.4203L16.5502 16.7056H5.57982C5.14051 16.7056 4.78195 17.0651 4.78195 17.5056V17.7806C4.78195 18.2211 5.14035 18.5806 5.57982 18.5806H14.6802L12.1568 21.1107L10.5301 24.9666L9.78747 24.2219C9.47678 23.9102 8.94859 23.8906 8.65896 24.2219L7.52838 25.5155C7.38365 25.6811 7.18386 25.7499 6.96428 25.7499H4.53796C4.09865 25.7499 3.7401 26.1094 3.7401 26.5499V26.825C3.7401 27.2654 4.0985 27.625 4.53796 27.625H7.73886C7.95859 27.625 8.17832 27.572 8.30311 27.3906L8.65912 26.8734C8.90869 26.5109 9.47662 26.5618 9.78747 26.8733L10.7088 27.7968L16.4123 25.3778L23.2388 18.5333V29.325C23.2388 29.7654 22.8802 30.125 22.4409 30.125ZM28.5941 10.512L27.9329 11.1749L26.3219 9.55952L26.9832 8.89664C27.3478 8.53104 27.9408 8.53104 28.3054 8.89664L28.5942 9.18608C28.9587 9.55168 28.9587 10.1466 28.5941 10.512ZM8.21295 9.2056H16.8957C17.3352 9.2056 17.6936 9.56512 17.6936 10.0056V10.2806C17.6936 10.7211 17.335 11.0806 16.8957 11.0806H8.21295C7.77365 11.0806 7.41508 10.7213 7.41508 10.2806V10.0056C7.41508 9.56496 7.77348 9.2056 8.21295 9.2056Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div className="itemMenu">UMOWY LOJALNOŚCIOWE</div>
                </div>
                <div className="accentAfter">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M 0 0 V 0 C 5.5229 0 10 4.4771 10 10 V 10 H 10 V 0 Z"
                      fill="#fff"
                    />
                  </svg>
                </div>
              </NavLink>
            </AuthResources>

            <AuthResources requiredRoles={['admin_phr']}>
              <>
                <NavLink
                  to="/administracja/IDP/pracownicy"
                  className="linkItemMenu"
                >
                  <div className="accentBefore">
                    <svg
                      width="10"
                      height="10"
                      viewBox="0 0 10 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M 10 10 H 10 V 0 C 10 5.5229 5.5229 10 0 10 V 10 V 10 Z"
                        fill="#fff"
                      />
                    </svg>
                  </div>
                  <div className="itemMenuBlock">
                    <div className="accentActive" />
                    <div className="iconItemMenu">
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M29.1876 0H2.81254C1.26164 0 0 1.26164 0 2.81245V29.1875C0 30.7383 1.26164 32 2.81254 32H29.1876C30.7384 32 32 30.7384 32 29.1875V2.81245C32 1.26164 30.7384 0 29.1876 0ZM1.87503 2.81245C1.87503 2.29554 2.29554 1.87503 2.81254 1.87503H22.625V7.50002H1.87503V2.81245ZM30.125 29.1875C30.125 29.7045 29.7045 30.125 29.1876 30.125H2.81254C2.29554 30.125 1.87503 29.7045 1.87503 29.1875V9.37495H30.125V29.1875ZM30.125 7.50002H24.5V1.87503H29.1876C29.7045 1.87503 30.125 2.29554 30.125 2.81245V7.50002ZM6.5625 3.74996H4.68748C4.1697 3.74996 3.74996 4.1697 3.74996 4.68748C3.74996 5.20525 4.1697 5.62499 4.68748 5.62499H6.5625C7.08027 5.62499 7.50002 5.20525 7.50002 4.68748C7.50002 4.1698 7.08027 3.74996 6.5625 3.74996ZM12.25 3.74996H10.375C9.85729 3.74996 9.43754 4.1697 9.43754 4.68748C9.43754 5.20525 9.85729 5.62499 10.375 5.62499H12.25C12.7678 5.62499 13.1875 5.20525 13.1875 4.68748C13.1875 4.1698 12.7678 3.74996 12.25 3.74996ZM17.875 3.74996H16C15.4823 3.74996 15.0625 4.1697 15.0625 4.68748C15.0625 5.20525 15.4823 5.62499 16 5.62499H17.875C18.3928 5.62499 18.8125 5.20525 18.8125 4.68748C18.8125 4.1698 18.3928 3.74996 17.875 3.74996ZM27.3125 26.375H26.375V14.125C26.375 13.6072 25.9553 13.1875 25.4375 13.1875H21.6875C21.1698 13.1875 20.75 13.6072 20.75 14.125V26.375H18.8125V17.875C18.8125 17.3572 18.3928 16.9375 17.875 16.9375H14.125C13.6072 16.9375 13.1875 17.3572 13.1875 17.875V26.375H11.3125V21.6249C11.3125 21.1073 10.8927 20.6875 10.3751 20.6875H6.5625C6.04473 20.6875 5.62499 21.1073 5.62499 21.6249V26.375H4.68748C4.1697 26.375 3.74996 26.7948 3.74996 27.3125C3.74996 27.8302 4.1697 28.2499 4.68748 28.2499C12.2352 28.2499 19.764 28.2499 27.3125 28.2499C27.8303 28.2499 28.25 27.8302 28.25 27.3125C28.25 26.7948 27.8303 26.375 27.3125 26.375ZM9.43754 26.375H7.50002V22.5625H9.43754V26.375ZM16.9375 26.375H15.0625V18.8125H16.9375V26.375ZM24.5 26.375H22.625V15.0625H24.5V26.375Z"
                          fill="#074B32"
                        />
                      </svg>
                    </div>
                    <div className="itemMenu">INDYWIDUALNY PLAN ROZWOJU</div>
                  </div>
                  <div className="accentAfter">
                    <svg
                      width="10"
                      height="10"
                      viewBox="0 0 10 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M 0 0 V 0 C 5.5229 0 10 4.4771 10 10 V 10 H 10 V 0 Z"
                        fill="#fff"
                      />
                    </svg>
                  </div>
                </NavLink>
                <div className="subMenu">
                  <div className="fill" />
                  <div className="subMenuItemBox">
                    <NavLink
                      to="/administracja/IDP/pracownicy"
                      className="linkItemSubMenu"
                    >
                      LISTA PRACOWNIKÓW
                    </NavLink>
                  </div>
                </div>
              </>
            </AuthResources>
            <AuthResources requiredRoles={['admin_phr']}>
              <>
                <NavLink
                  to="/administracja/ocena-pracownika/pracownicy"
                  className="linkItemMenu"
                >
                  <div className="accentBefore">
                    <svg
                      width="10"
                      height="10"
                      viewBox="0 0 10 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M 10 10 H 10 V 0 C 10 5.5229 5.5229 10 0 10 V 10 V 10 Z"
                        fill="#fff"
                      />
                    </svg>
                  </div>
                  <div className="itemMenuBlock">
                    <div className="accentActive" />
                    <div className="iconItemMenu">
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M25.1131 14.3269L28.1675 11.3498C28.4443 11.0799 28.5441 10.6756 28.4246 10.3079C28.3051 9.93997 27.9871 9.67185 27.6044 9.6162L18.9976 8.36535L15.1486 0.566523C14.9773 0.219414 14.624 0 14.237 0C13.8502 0 13.4969 0.219619 13.3256 0.566523L9.47675 8.36535L0.86992 9.6162C0.487139 9.67185 0.169175 9.93987 0.049633 10.3079C-0.0697046 10.6756 0.0300674 11.0799 0.306858 11.3498L6.53467 17.4203L5.06439 25.9919C4.99927 26.3717 5.15723 26.7596 5.46878 26.9861C5.64264 27.1126 5.85145 27.1802 6.06628 27.1802C6.23118 27.1802 6.39322 27.1402 6.53915 27.0635L14.0904 23.0936L14.1175 23.5678C14.3876 28.2907 18.3187 32 23.0511 32C27.9854 32 32 27.9854 32 23.0511C32 19.0977 29.3892 15.6059 25.6112 14.4759L25.1131 14.3269ZM14.162 20.8569C14.023 20.8671 13.8876 20.9035 13.7641 20.9685L7.4161 24.306L8.62834 17.2374C8.6848 16.9083 8.57514 16.5708 8.33606 16.3377L3.20023 11.3317L10.2978 10.3002C10.6288 10.2521 10.915 10.0443 11.0631 9.7443L14.237 3.31282L17.4112 9.7442C17.5592 10.0441 17.8454 10.252 18.1763 10.3001L25.2738 11.3316L22.4081 14.125L22.2987 14.1342C18.5861 14.4445 15.4392 17.0541 14.4338 20.6346L14.3758 20.8411L14.162 20.8569ZM23.0511 29.9673C19.2373 29.9673 16.1349 26.8648 16.1349 23.0511C16.1349 19.2374 19.2373 16.135 23.0511 16.135C26.8648 16.135 29.9673 19.2374 29.9673 23.0511C29.9673 26.8649 26.8649 29.9673 23.0511 29.9673ZM25.1529 20.3934L21.9053 23.6409L20.8611 22.597C20.464 22.2 19.8208 22.2 19.4237 22.597C19.0267 22.9938 19.0268 23.6373 19.4237 24.0342L21.1865 25.7971C21.378 25.9885 21.6346 26.0947 21.9053 26.0947C22.1759 26.0947 22.4325 25.9884 22.6239 25.797L26.5902 21.8307C26.9872 21.4338 26.9872 20.7903 26.5902 20.3934C26.1933 19.9964 25.5498 19.9964 25.1529 20.3934Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div className="itemMenu">OCENA PRACOWNIKA</div>
                  </div>
                  <div className="accentAfter">
                    <svg
                      width="10"
                      height="10"
                      viewBox="0 0 10 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M 0 0 V 0 C 5.5229 0 10 4.4771 10 10 V 10 H 10 V 0 Z"
                        fill="#fff"
                      />
                    </svg>
                  </div>
                </NavLink>
                <div className="subMenu">
                  <div className="fill" />
                  <div className="subMenuItemBox">
                    <NavLink
                      to="/administracja/ocena-pracownika/pracownicy"
                      className="linkItemSubMenu"
                    >
                      LISTA PRACOWNIKÓW
                    </NavLink>
                  </div>
                </div>
              </>
            </AuthResources>
            <AuthResources requiredRoles={['admin_phr']}>
              <>
                <NavLink to="/administracja/Raporty" className="linkItemMenu">
                  <div className="itemMenuBlock">
                    <div className="accentActive" />
                    <div className="iconItemMenu">
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M29.1876 0H2.81254C1.26164 0 0 1.26164 0 2.81245V29.1875C0 30.7383 1.26164 32 2.81254 32H29.1876C30.7384 32 32 30.7384 32 29.1875V2.81245C32 1.26164 30.7384 0 29.1876 0ZM1.87503 2.81245C1.87503 2.29554 2.29554 1.87503 2.81254 1.87503H22.625V7.50002H1.87503V2.81245ZM30.125 29.1875C30.125 29.7045 29.7045 30.125 29.1876 30.125H2.81254C2.29554 30.125 1.87503 29.7045 1.87503 29.1875V9.37495H30.125V29.1875ZM30.125 7.50002H24.5V1.87503H29.1876C29.7045 1.87503 30.125 2.29554 30.125 2.81245V7.50002ZM6.5625 3.74996H4.68748C4.1697 3.74996 3.74996 4.1697 3.74996 4.68748C3.74996 5.20525 4.1697 5.62499 4.68748 5.62499H6.5625C7.08027 5.62499 7.50002 5.20525 7.50002 4.68748C7.50002 4.1698 7.08027 3.74996 6.5625 3.74996ZM12.25 3.74996H10.375C9.85729 3.74996 9.43754 4.1697 9.43754 4.68748C9.43754 5.20525 9.85729 5.62499 10.375 5.62499H12.25C12.7678 5.62499 13.1875 5.20525 13.1875 4.68748C13.1875 4.1698 12.7678 3.74996 12.25 3.74996ZM17.875 3.74996H16C15.4823 3.74996 15.0625 4.1697 15.0625 4.68748C15.0625 5.20525 15.4823 5.62499 16 5.62499H17.875C18.3928 5.62499 18.8125 5.20525 18.8125 4.68748C18.8125 4.1698 18.3928 3.74996 17.875 3.74996ZM27.3125 26.375H26.375V14.125C26.375 13.6072 25.9553 13.1875 25.4375 13.1875H21.6875C21.1698 13.1875 20.75 13.6072 20.75 14.125V26.375H18.8125V17.875C18.8125 17.3572 18.3928 16.9375 17.875 16.9375H14.125C13.6072 16.9375 13.1875 17.3572 13.1875 17.875V26.375H11.3125V21.6249C11.3125 21.1073 10.8927 20.6875 10.3751 20.6875H6.5625C6.04473 20.6875 5.62499 21.1073 5.62499 21.6249V26.375H4.68748C4.1697 26.375 3.74996 26.7948 3.74996 27.3125C3.74996 27.8302 4.1697 28.2499 4.68748 28.2499C12.2352 28.2499 19.764 28.2499 27.3125 28.2499C27.8303 28.2499 28.25 27.8302 28.25 27.3125C28.25 26.7948 27.8303 26.375 27.3125 26.375ZM9.43754 26.375H7.50002V22.5625H9.43754V26.375ZM16.9375 26.375H15.0625V18.8125H16.9375V26.375ZM24.5 26.375H22.625V15.0625H24.5V26.375Z"
                          fill="#1D4370"
                        />
                      </svg>
                    </div>
                    <div className="itemMenu">RAPORTY</div>
                  </div>
                </NavLink>
              </>
            </AuthResources>
          </>
        </AuthResources>
      );
    }
  }

  function MenuSettings() {
    // const location = useLocation();
    if (matchPath(useLocation().pathname, { path: '/ustawienia' })) {
      return (
        <AuthResources requiredRoles={['admin_phr', 'training_department']}>
          <>
            <NavLink to="/ustawienia/panel" className="linkItemMenu">
              <div className="itemMenuBlock">
                <div className="accentActive" />
                <div className="iconItemMenu">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M9.091 4.66666H5.69701C4.96267 4.66666 4.36366 5.26566 4.36366 6.00001V9.99999H6.06069V6.33331H9.091V4.66666ZM27.615 15.5383H25.918V19.205H22.8876V20.8717H26.2816C27.016 20.8717 27.615 20.2727 27.615 19.5383V15.5383ZM29.9697 23.3333H2.03033V2.00003H29.9697V23.3333ZM10.606 30.6666V31.3333C10.606 31.7006 10.9054 32 11.2727 32H20.7273C21.0946 32 21.394 31.7006 21.394 31.3333V30.6666C21.394 30.2993 21.0946 30 20.7273 30H19.0303C18.663 30 18.3636 29.7007 18.3636 29.3333V25.3333H29.6363C30.2733 25.3333 30.86 25.0443 31.2859 24.5757C31.7567 24.058 32 23.3627 32 22.6667V2.66663C32 1.971 31.7563 1.27569 31.2859 0.758334C30.86 0.289692 30.2737 0 29.6363 0H2.36364C0.939635 0 0 1.32065 0 2.66663V22.6667C0 23.3627 0.243325 24.058 0.713983 24.5753C1.14002 25.0443 1.72633 25.3333 2.36364 25.3333H13.6363V29.3333C13.6363 29.7007 13.337 30 12.9697 30H11.2727C10.9054 30 10.606 30.2993 10.606 30.6666Z" />
                  </svg>
                </div>
                <div className="itemMenu">{t('menu.desktopSetting')}</div>
              </div>
              <div className="accentAfter">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M 0 0 V 0 C 5.5229 0 10 4.4771 10 10 V 10 H 10 V 0 Z"
                    fill="#fff"
                  />
                </svg>
              </div>
            </NavLink>
            <NavLink to="/ustawienia/szkolenia" className="linkItemMenu">
              <div className="accentBefore">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M 10 10 H 10 V 0 C 10 5.5229 5.5229 10 0 10 V 10 V 10 Z"
                    fill="#fff"
                  />
                </svg>
              </div>
              <div className="itemMenuBlock">
                <div className="accentActive" />
                <div className="iconItemMenu">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M6.40017 0C3.75324 0.000562484 1.60019 2.15356 1.60019 4.80042C1.60019 7.44729 3.75324 9.59979 6.40017 9.59979C9.04709 9.59979 11.2001 7.44679 11.2001 4.79992C11.2001 2.153 9.04709 0 6.40017 0ZM6.40017 8.00033C4.63274 8.00033 3.20018 6.56781 3.20018 4.80042C3.20018 3.03304 4.63274 1.60052 6.40017 1.60052C8.1676 1.60052 9.60015 3.03304 9.60015 4.80042C9.60015 6.56781 8.16766 8.00033 6.40017 8.00033Z" />
                    <path d="M30.4001 7.99977H14.4001C13.5164 7.99977 12.8001 8.716 12.8001 9.59972V10.8216L14.4001 11.6215V9.59972H30.4001V22.3988H14.4001V20.497L12.8001 20.0975V22.3988C12.8001 23.2825 13.5164 23.9987 14.4001 23.9987H20.9879L16.9142 30.7874C16.686 31.1655 16.8097 31.6577 17.1894 31.8844C17.5644 32.1143 18.0582 31.9905 18.2865 31.6092L21.6001 26.0862V31.198C21.6001 31.6402 21.958 31.998 22.4001 31.998C22.8422 31.998 23.2001 31.6402 23.2001 31.198V26.0862L26.5142 31.6087C26.6641 31.8588 26.9296 31.9975 27.2001 31.9975C27.3409 31.9975 27.4828 31.9618 27.6113 31.8834C27.991 31.6567 28.1142 31.1645 27.8865 30.7864L23.8128 23.9977H30.4C31.2838 23.9977 32 23.2815 32 22.3978V9.59972C32.0001 8.716 31.2838 7.99977 30.4001 7.99977Z" />
                    <path d="M27.9686 12.5794C27.8481 12.1543 27.406 11.9042 26.9798 12.0312L17.1073 14.8519C16.9921 14.7405 16.8631 14.6428 16.7159 14.5687L10.3159 11.3688C10.0935 11.2579 9.84871 11.1997 9.60015 11.1997H3.20018C2.42687 11.1997 1.76443 11.7528 1.62581 12.5133L0.025817 21.3125C-0.0589952 21.7792 0.0674418 22.2597 0.371441 22.6239C0.675439 22.9882 1.12556 23.1988 1.60025 23.1988H2.62262L3.20555 30.525C3.27168 31.357 3.96555 31.998 4.80023 31.998H8.00022C8.81566 31.998 9.50047 31.3852 9.59059 30.5751L10.9885 17.9957L15.6124 19.1515C15.7404 19.1835 15.8706 19.1989 16.0002 19.1989C16.3533 19.1989 16.7004 19.0821 16.9847 18.8602C17.373 18.5573 17.6002 18.0917 17.6002 17.5989V16.3739L27.4204 13.5681C27.8455 13.4476 28.0908 13.0039 27.9686 12.5794ZM16.0001 17.5995L9.60015 15.9995L8.00016 30.3986H4.80017L4.10043 21.5989H1.60019L3.20018 12.7997H5.60017V17.6667C5.60017 18.1089 5.95804 18.4667 6.40017 18.4667C6.84229 18.4667 7.20016 18.1089 7.20016 17.6667V12.7996H9.60015L16.0001 15.9995V17.5995Z" />
                  </svg>
                </div>
                <div className="itemMenu">{t('menuSettings.trainings')}</div>
              </div>
              <div className="accentAfter">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M 0 0 V 0 C 5.5229 0 10 4.4771 10 10 V 10 H 10 V 0 Z"
                    fill="#fff"
                  />
                </svg>
              </div>
            </NavLink>
            <div className="subMenu">
              <div className="fill" />
              <div className="subMenuItemBox">
                <NavLink
                  to="/ustawienia/szkolenia/szkolenia-i-kompetencje"
                  className="linkItemSubMenu"
                >
                  {t('menuSettings.trainingsAndCompetetion')}
                </NavLink>
                <NavLink
                  to="/ustawienia/szkolenia/katalog-szkolen"
                  className="linkItemSubMenu"
                >
                  {t('menuSettings.trainingsCatalog')}
                </NavLink>
                <NavLink
                  to="/ustawienia/szkolenia/plan-szkolen"
                  className="linkItemSubMenu"
                >
                  {t('menuSettings.plansTrainings')}
                </NavLink>
                <NavLink
                  to="/ustawienia/szkolenia/dostawcy-szkolen"
                  className="linkItemSubMenu"
                >
                  {t('menuSettings.trainingsProvider')}
                </NavLink>
                <NavLink
                  to="/ustawienia/szkolenia/osoby-kontaktowe"
                  className="linkItemSubMenu"
                >
                  {t('menuSettings.trainingsContactCompany')}
                </NavLink>
              </div>
            </div>
            <NavLink to="/ustawienia/IDP" className="linkItemMenu">
              <div className="accentBefore">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M 10 10 H 10 V 0 C 10 5.5229 5.5229 10 0 10 V 10 V 10 Z"
                    fill="#fff"
                  />
                </svg>
              </div>
              <div className="itemMenuBlock">
                <div className="accentActive" />
                <div className="iconItemMenu">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M29.1876 0H2.81254C1.26164 0 0 1.26164 0 2.81245V29.1875C0 30.7383 1.26164 32 2.81254 32H29.1876C30.7384 32 32 30.7384 32 29.1875V2.81245C32 1.26164 30.7384 0 29.1876 0ZM1.87503 2.81245C1.87503 2.29554 2.29554 1.87503 2.81254 1.87503H22.625V7.50002H1.87503V2.81245ZM30.125 29.1875C30.125 29.7045 29.7045 30.125 29.1876 30.125H2.81254C2.29554 30.125 1.87503 29.7045 1.87503 29.1875V9.37495H30.125V29.1875ZM30.125 7.50002H24.5V1.87503H29.1876C29.7045 1.87503 30.125 2.29554 30.125 2.81245V7.50002ZM6.5625 3.74996H4.68748C4.1697 3.74996 3.74996 4.1697 3.74996 4.68748C3.74996 5.20525 4.1697 5.62499 4.68748 5.62499H6.5625C7.08027 5.62499 7.50002 5.20525 7.50002 4.68748C7.50002 4.1698 7.08027 3.74996 6.5625 3.74996ZM12.25 3.74996H10.375C9.85729 3.74996 9.43754 4.1697 9.43754 4.68748C9.43754 5.20525 9.85729 5.62499 10.375 5.62499H12.25C12.7678 5.62499 13.1875 5.20525 13.1875 4.68748C13.1875 4.1698 12.7678 3.74996 12.25 3.74996ZM17.875 3.74996H16C15.4823 3.74996 15.0625 4.1697 15.0625 4.68748C15.0625 5.20525 15.4823 5.62499 16 5.62499H17.875C18.3928 5.62499 18.8125 5.20525 18.8125 4.68748C18.8125 4.1698 18.3928 3.74996 17.875 3.74996ZM27.3125 26.375H26.375V14.125C26.375 13.6072 25.9553 13.1875 25.4375 13.1875H21.6875C21.1698 13.1875 20.75 13.6072 20.75 14.125V26.375H18.8125V17.875C18.8125 17.3572 18.3928 16.9375 17.875 16.9375H14.125C13.6072 16.9375 13.1875 17.3572 13.1875 17.875V26.375H11.3125V21.6249C11.3125 21.1073 10.8927 20.6875 10.3751 20.6875H6.5625C6.04473 20.6875 5.62499 21.1073 5.62499 21.6249V26.375H4.68748C4.1697 26.375 3.74996 26.7948 3.74996 27.3125C3.74996 27.8302 4.1697 28.2499 4.68748 28.2499C12.2352 28.2499 19.764 28.2499 27.3125 28.2499C27.8303 28.2499 28.25 27.8302 28.25 27.3125C28.25 26.7948 27.8303 26.375 27.3125 26.375ZM9.43754 26.375H7.50002V22.5625H9.43754V26.375ZM16.9375 26.375H15.0625V18.8125H16.9375V26.375ZM24.5 26.375H22.625V15.0625H24.5V26.375Z"
                      fill="#1D4370"
                    />
                  </svg>
                </div>
                <div className="itemMenu">INDYWIDUALNY PLAN ROZWOJU</div>
              </div>
              <div className="accentAfter">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M 0 0 V 0 C 5.5229 0 10 4.4771 10 10 V 10 H 10 V 0 Z"
                    fill="#fff"
                  />
                </svg>
              </div>
            </NavLink>
            <div className="subMenu">
              <div className="fill" />
              <div className="subMenuItemBox">
                <NavLink
                  to="/ustawienia/IDP/formularz"
                  className="linkItemSubMenu"
                >
                  KONFIGURACJA IDP
                </NavLink>
              </div>
            </div>
            <NavLink to="/ustawienia/ocena-pracownika" className="linkItemMenu">
              <div className="accentBefore">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M 10 10 H 10 V 0 C 10 5.5229 5.5229 10 0 10 V 10 V 10 Z"
                    fill="#fff"
                  />
                </svg>
              </div>
              <div className="itemMenuBlock">
                <div className="accentActive" />
                <div className="iconItemMenu">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M25.1131 14.3269L28.1675 11.3498C28.4443 11.0799 28.5441 10.6756 28.4246 10.3079C28.3051 9.93997 27.9871 9.67185 27.6044 9.6162L18.9976 8.36535L15.1486 0.566523C14.9773 0.219414 14.624 0 14.237 0C13.8502 0 13.4969 0.219619 13.3256 0.566523L9.47675 8.36535L0.86992 9.6162C0.487139 9.67185 0.169175 9.93987 0.049633 10.3079C-0.0697046 10.6756 0.0300674 11.0799 0.306858 11.3498L6.53467 17.4203L5.06439 25.9919C4.99927 26.3717 5.15723 26.7596 5.46878 26.9861C5.64264 27.1126 5.85145 27.1802 6.06628 27.1802C6.23118 27.1802 6.39322 27.1402 6.53915 27.0635L14.0904 23.0936L14.1175 23.5678C14.3876 28.2907 18.3187 32 23.0511 32C27.9854 32 32 27.9854 32 23.0511C32 19.0977 29.3892 15.6059 25.6112 14.4759L25.1131 14.3269ZM14.162 20.8569C14.023 20.8671 13.8876 20.9035 13.7641 20.9685L7.4161 24.306L8.62834 17.2374C8.6848 16.9083 8.57514 16.5708 8.33606 16.3377L3.20023 11.3317L10.2978 10.3002C10.6288 10.2521 10.915 10.0443 11.0631 9.7443L14.237 3.31282L17.4112 9.7442C17.5592 10.0441 17.8454 10.252 18.1763 10.3001L25.2738 11.3316L22.4081 14.125L22.2987 14.1342C18.5861 14.4445 15.4392 17.0541 14.4338 20.6346L14.3758 20.8411L14.162 20.8569ZM23.0511 29.9673C19.2373 29.9673 16.1349 26.8648 16.1349 23.0511C16.1349 19.2374 19.2373 16.135 23.0511 16.135C26.8648 16.135 29.9673 19.2374 29.9673 23.0511C29.9673 26.8649 26.8649 29.9673 23.0511 29.9673ZM25.1529 20.3934L21.9053 23.6409L20.8611 22.597C20.464 22.2 19.8208 22.2 19.4237 22.597C19.0267 22.9938 19.0268 23.6373 19.4237 24.0342L21.1865 25.7971C21.378 25.9885 21.6346 26.0947 21.9053 26.0947C22.1759 26.0947 22.4325 25.9884 22.6239 25.797L26.5902 21.8307C26.9872 21.4338 26.9872 20.7903 26.5902 20.3934C26.1933 19.9964 25.5498 19.9964 25.1529 20.3934Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div className="itemMenu">OCENA PRACOWNIKA</div>
              </div>
              <div className="accentAfter">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M 0 0 V 0 C 5.5229 0 10 4.4771 10 10 V 10 H 10 V 0 Z"
                    fill="#fff"
                  />
                </svg>
              </div>
            </NavLink>
            <div className="subMenu">
              <div className="fill" />
              <div className="subMenuItemBox">
                <NavLink
                  to="/ustawienia/ocena-pracownika/formularz"
                  className="linkItemSubMenu"
                >
                  KONFIGURACJA
                </NavLink>
              </div>
            </div>
          </>
        </AuthResources>
      );
    }
  }

  return (
    <div className="menu">
      {MenuPanel()}
      {MenuManager()}
      {MenuAdministration()}
      {MenuSettings()}

      <AuthResources requiredRoles={['user']}>
        <>{showModalIDP ? <IDPShow changeModalEdit={setShowModalIDP} /> : ''}</>
      </AuthResources>

      <AuthResources requiredRoles={['user']}>
        <>
          {showModalAppraisal ? (
            <AppraisalModalSelect changeModalEdit={setShowModalAppraisal} />
          ) : (
            ''
          )}
        </>
      </AuthResources>

      <div className="fill" />
    </div>
  );
};

export default MenuBoxComp;
